import { Text } from "@/components";

export const SubHeading = ({ children, className }: { children: React.ReactNode, className?: string }) => {
  return (
    <Text.Heading size="sm" className={`text-[28px] sm:text-[36px] mb-6 ${className}`}>
      {children}
    </Text.Heading>
  );
};
  
export const Quote = ({ children, className="" }: { children: React.ReactNode, className?: string }) => {
  return (
    <strong className={`font-bold text-[#33DAE1] text-[20px] leading-[28px] sm:text-[24px] sm:leading-[32px] ${className}`}>
      {children}
    </strong>
  );
};
  
export const Paragraph = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="text-left text-[20px] leading-[28px] sm:text-[24px] sm:leading-[32px]">
      {children}
    </div>
  );
};
  
export const LineBreak = () => {
  return (
    <div className="my-6"></div>
  );
};
